import { createBrowserRouter } from "react-router-dom";
import LandingScreen from "../screens/LandingScreen/LandingScreen";
import MainScreen from "../screens/MainScreen.tsx/MainScreen";
import ManageScreen from "../screens/ManageScreen/ManageScreen";
import React from "react";
import DetailsScreen from "../screens/DetailsScreen/DetailsScreen";
import EditScreen from "../screens/EditScreen/EditScreen";

export const router = createBrowserRouter([
  {
    path: "",
    element: <LandingScreen />,
  },
  {
    path: "/",
    element: <LandingScreen />,
  },
  {
    path: "/main",
    element: <MainScreen />,
  },
  {
    path: "/manage",
    element: <ManageScreen />,
  },
  {
    path: "/details/:videoId/:searchKeyword?",
    element: <DetailsScreen />,
  },
  {
    path: "/edit/:videoId",
    element: <EditScreen />,
  },
]);
